import { useEffect, useState } from 'react'

import { Button, Card, Row, SuccessModal } from 'components'
import { useModal, usePersistForm } from 'hooks'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import { useForm } from 'react-hook-form'
import {
  RequestRolDocs,
  RolDocumento,
  RolDocumentsServices
} from 'services/NGT/Parameterization'
import { FORMAT, SPACING } from 'utils'
import { createArrayCopy } from 'utils/functions'

import {
  FilterRollDocuments,
  ModalEditRolDocs,
  TableRollDocuments
} from './components'
import ModalRegisterRollDocs from './components/ModalRegisterRollDocs'

export type TypeAction = 'edit' | 'delete'

interface IFormRol {
  nuItem: string
  txtTipoDocumento: string
  descPendencia: string
  tipoPendencia: string
  cdTipoEfetivo: string
  cdStatusEfetivo: string
}

const RollDocuments = () => {
  const { showModal } = useModal()
  const {
    control,
    watch,
    setValue,
    getValues
  } = useForm<IFormRol>()
  const { setLoading, setMsgErro } = useLoading()
  const [listRollDocs, setListRollDocs] = useState<RolDocumento[] | undefined>()
  const [modalRollDocs, toggleModalRollDocs] = useToggle()
  const [modalEditRolDoc, toggleModalEditRolDoc] = useToggle()
  const [deleteAlert, toggleDeleteAlert] = useToggle()
  const [createSucessAlert, toggleCreateSucessAlert] = useToggle()
  const [editSucessAlert, toggleEditSucessAlert] = useToggle()
  //FILTERS
  const [rolDocs, setRolDocs] = useState<any[] | undefined>()
  const [pendencias, setPendencias] = useState<any[] | undefined>()
  const [tipos, setTipos] = useState<any[] | undefined>()
  const [tipoEfetivo, setTipoEfetivo] = useState<any[] | undefined>()
  const [status, setStatus] = useState<any[] | undefined>()
  const [selectedRolDoc, setSelectedRolDoc] = useState<RolDocumento | undefined>()

  //FOOTERTABLE
  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)

  usePersistForm('parametrizacao-roll-documentos-ngt-form', {
    setValue,
    watch
  })

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const fillSelectList = (condition, callback, data) => {
    condition && callback(data)
  }

  const g = () => {
    const value = getValues()

    const getRollDocs = new Promise((resolve, reject) =>
      RolDocumentsServices()
        .getFiltroRolDocumento(value)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao realizar a pesquisa',
            type: 'error'
          })
        })
    )

    const getParametros = new Promise((resolve, reject) =>
      RolDocumentsServices()
        .getParametrosFiltros()
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err)
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao realizar a pesquisa',
            type: 'error'
          })
        })
    )
    setLoading('loading')
    Promise.allSettled([getRollDocs, getParametros])
      .then((values: any[]) => {
        //values[0] retorno lista roll
        values[0].status === 'fulfilled' &&
          setListRollDocs(values[0].value.entity)

        //values[1] retorno lista parametros
        values[1].status === 'fulfilled' &&
          values[1].value.entity?.forEach((el) => {
            const listSelects = [{ label: 'Selecione', value: null }]
            el.valores.map((p) => listSelects.push({ label: p, value: p }))
            fillSelectList(
              el.chave === 'Rol de Documentos',
              setRolDocs,
              listSelects
            )
            fillSelectList(el.chave === 'Pendencia', setPendencias, listSelects)
            fillSelectList(el.chave === 'TipoPendencia', setTipos, listSelects)
            fillSelectList(
              el.chave === 'Tipo Efetivo',
              setTipoEfetivo,
              listSelects
            )
            fillSelectList(
              el.chave === 'Status do Efetivo',
              setStatus,
              listSelects
            )
          })

        values?.forEach((el) => {
          if (el.status === 'rejected') {
            setLoading('error')
            setMsgErro(el?.reason?.message)
            return
          }
        })
        setLoading('idle')
      })
      .catch((err) => {
        // setLoading('error')
        // setMsgErro(err)
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: err.title,
          type: 'error'
        })
      })
  }
  // ! GET ROL DOCS
  useEffect(() => {
    g()
  }, [])
  const value = getValues()
  // ! LISTENER FORM
  const handleFilter = () => {
    setLoading('loading')

    Object.keys(value).forEach((key) => {
      if (value[key] === undefined || value[key] === null) {
        delete value[key]
      }
    })

    RolDocumentsServices()
      .getFiltroRolDocumento(value)
      .then(({ data }) => {
        if (!data.sucesso) {
          setLoading('error')
          setMsgErro(data.mensagem || 'Não foi possivel filtrar')
          return
        }
        setPage(0)
        setListRollDocs(data.entity)
        setLoading('idle')
      })
      .catch((err) => {
        // setMsgErro(err)
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: err.title,
          type: 'error'
        })
      })
  }

  const handleModalSubmit = async (requestObj: any) => {
    setLoading('loading')

    const newRequestObj = formatData(requestObj)

    try {
      const response = await RolDocumentsServices().createRolDocs(newRequestObj)

      if (!response.data.sucesso) throw new Error(response.data.mensagem)
      const cpy: RolDocumento[] = createArrayCopy(listRollDocs)
      cpy.push(response.data.valor)
      setListRollDocs(cpy)
      toggleModalRollDocs()
      toggleCreateSucessAlert()
      setLoading('idle')
    } catch (error: any) {
      setMsgErro('Não foi possivel adicionar no Rol de Documento')
      setLoading('error')
    }
  }

  const handleEditModal = async (requestObj: RequestRolDocs) => {
    setLoading('loading')
    try {
      const response = await RolDocumentsServices().updateRolDocs(
        Object.assign(selectedRolDoc, formatData(requestObj))
      )
      if (!response.data.sucesso) throw new Error(response.data)

      // const cpy: RolDocumento[] = createArrayCopy(listRollDocs)
      // cpy.push(response.data.valor)
      // const index = cpy.findIndex(
      //   (el) => el.idRolDocumento === response.data?.valor?.idRolDocumento
      // )
      g()
      // cpy[index] = Object.assign(cpy[index], response.data.valor)
      toggleEditSucessAlert()
      // setListRollDocs(cpy)
      toggleModalEditRolDoc()
      setLoading('idle')
    } catch (error: any) {
      setMsgErro(error.title)
      setLoading('error')
    }
  }

  const handleSelectRolDoc = (data: any, typeAction: TypeAction) => {
    setSelectedRolDoc(data)
    typeAction === 'edit' && toggleModalEditRolDoc()
    typeAction === 'delete' && toggleDeleteAlert()
  }

  const handleDeleteRolDoc = () => {
    toggleDeleteAlert()
    setLoading('loading')
    RolDocumentsServices()
      .deleteRolDocs(selectedRolDoc.idRolDocumento)
      .then(({ data }) => {
        if (data.sucesso) {
          const cpy: RolDocumento[] = createArrayCopy(listRollDocs)
          const filtered = cpy.filter(
            (el) => el.idRolDocumento !== data.valor.idRolDocumento
          )

          setListRollDocs(filtered)
          showModal({
            hideButtonCancel: true,
            message: 'Deletado com sucesso',
            txtButtonConfirm: 'Fechar',
            type: 'success'
          })
        }
        setLoading('idle')
      })
      .catch((err) => {
        // setMsgErro(err.title)
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: err.title,
          type: 'error'
        })
      })
  }
  const handleReset = () => {
    setValue('cdStatusEfetivo', '')
    setValue('cdTipoEfetivo', '')
    setValue('descPendencia', '')
    setValue('nuItem', '')
    setValue('tipoPendencia', '')
    setValue('txtTipoDocumento', '')
    setValue('cdStatusEfetivo', '')

    g()
  }

  const orderList = (list: Array<any>) =>
    FORMAT.orderByPropText(
      FORMAT.orderByPropValue(list, 'nuItem'),
      'cdTipoEfetivo'
    )

  const formatData = (data: any) => {
    return {
      ...data,
      nuIndice: Number(data.nuIndice) === 0 ? null : Number(data.nuIndice),
      rolPrincipalId: data.rolPrincipalId >= 0 ? data.rolPrincipalId : null
    }
  }

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <FilterRollDocuments
          control={control}
          rolDocs={rolDocs}
          pendencias={pendencias}
          tipos={tipos}
          tipoEfetivo={tipoEfetivo}
          status={status}
        />
        <Row justifyContent="flex-end" alignItems="center">
          <Button
            text="Limpar"
            variantButton="text"
            onClick={handleReset}
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing5}
            marginRight={SPACING.spacing15}
          />
          <Button
            text="Buscar"
            variantButton="outlined"
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing5}
            marginRight={SPACING.spacing15}
            onClick={handleFilter}
          />
          <Button
            text="Adicionar novo"
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing5}
            onClick={toggleModalRollDocs}
          />
        </Row>
        <TableRollDocuments
          tableData={orderList(listRollDocs) || []}
          handleSelectRolDoc={handleSelectRolDoc}
          handleChangePage={handleChangePage}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Card>
      {!!modalRollDocs && (
        <ModalRegisterRollDocs
          showModal={modalRollDocs}
          toggleModal={toggleModalRollDocs}
          onSubmit={handleModalSubmit}
        />
      )}
      {!!modalEditRolDoc && (
        <ModalEditRolDocs
          showModal={modalEditRolDoc}
          toggleModal={toggleModalEditRolDoc}
          rolDocSelected={selectedRolDoc}
          onSubmit={handleEditModal}
        />
      )}
      {!!deleteAlert && (
        <SuccessModal
          open={deleteAlert}
          type="alert"
          message="Deseja apagar esse Rol Documento?"
          txtButtonCancel="Voltar"
          txtButtonConfirm="Apagar"
          handleCancel={toggleDeleteAlert}
          handleConfirm={handleDeleteRolDoc}
        />
      )}
      {!!createSucessAlert && (
        <SuccessModal
          open={createSucessAlert}
          type="sucess"
          message="Novo Item Rol Documento Adicionado."
          txtButtonConfirm="Continuar"
          hideButtonCancel
          handleConfirm={toggleCreateSucessAlert}
        />
      )}
      {!!editSucessAlert && (
        <SuccessModal
          open={editSucessAlert}
          type="sucess"
          message="Item editado com sucesso"
          txtButtonConfirm="Continuar"
          hideButtonCancel
          handleConfirm={toggleEditSucessAlert}
        />
      )}
    </>
  )
}

export default RollDocuments
